export const GET_PUNCH_IN_CALL = 'GET_PUNCH_IN_CALL';
export const GET_PUNCH_IN_DONE = 'GET_PUNCH_IN_DONE';
export const GET_PUNCH_IN_FAIL = 'GET_PUNCH_IN_FAIL';

export const POST_PUNCH_IN_RECORD_CALL = 'POST_PUNCH_IN_RECORD_CALL';
export const POST_PUNCH_IN_RECORD_DONE = 'POST_PUNCH_IN_RECORD_DONE';
export const POST_PUNCH_IN_RECORD_FAIL = 'POST_PUNCH_IN_RECORD_FAIL';

export const POST_PUNCH_IN_RECORD_QUEUE_CALL = 'POST_PUNCH_IN_RECORD_QUEUE_CALL';
export const POST_PUNCH_IN_RECORD_QUEUE_DONE = 'POST_PUNCH_IN_RECORD_QUEUE_DONE';
export const POST_PUNCH_IN_RECORD_QUEUE_FAIL = 'POST_PUNCH_IN_RECORD_QUEUE_FAIL';

export const GET_DAY_SHIFTS_CALL = 'GET_DAY_SHIFTS_CALL';
export const GET_DAY_SHIFTS_DONE = 'GET_DAY_SHIFTS_DONE';
export const GET_DAY_SHIFTS_FAIL = 'GET_DAY_SHIFTS_FAIL';

export const GET_ALL_SHIFTS_CALL = 'GET_ALL_SHIFTS_CALL';
export const GET_ALL_SHIFTS_DONE = 'GET_ALL_SHIFTS_DONE';
export const GET_ALL_SHIFTS_FAIL = 'GET_ALL_SHIFTS_FAIL';

export const GET_SUITABLE_SHIFTS_CALL = 'GET_SUITABLE_SHIFTS_CALL';
export const GET_SUITABLE_SHIFTS_DONE = 'GET_SUITABLE_SHIFTS_DONE';
export const GET_SUITABLE_SHIFTS_FAIL = 'GET_SUITABLE_SHIFTS_FAIL';

export const GET_SCHEDULE_SHIFTS_CALL = 'GET_SCHEDULE_SHIFTS_CALL';
export const GET_SCHEDULE_SHIFTS_DONE = 'GET_SCHEDULE_SHIFTS_DONE';
export const GET_SCHEDULE_SHIFTS_FAIL = 'GET_SCHEDULE_SHIFTS_FAIL';

export const GET_DAILY_SHIFTS_CALL = 'GET_DAILY_SHIFTS_CALL';
export const GET_DAILY_SHIFTS_DONE = 'GET_DAILY_SHIFTS_DONE';
export const GET_DAILY_SHIFTS_FAIL = 'GET_DAILY_SHIFTS_FAIL';

export const GET_REST_PUNCH_RECORD_CALL = 'GET_REST_PUNCH_RECORD_CALL';
export const GET_REST_PUNCH_RECORD_DONE = 'GET_REST_PUNCH_RECORD_DONE';
export const GET_REST_PUNCH_RECORD_FAIL = 'GET_REST_PUNCH_RECORD_FAIL';
export const CLEAR_REST_PUNCH_RECORD = 'CLEAR_REST_PUNCH_RECORD';

export const POST_REST_PUNCH_RECORD_CALL = 'POST_REST_PUNCH_RECORD_CALL';
export const POST_REST_PUNCH_RECORD_DONE = 'POST_REST_PUNCH_RECORD_DONE';
export const POST_REST_PUNCH_RECORD_FAIL = 'POST_REST_PUNCH_RECORD_FAIL';

export const DELETE_REST_PUNCH_RECORD_CALL = 'DELETE_REST_PUNCH_RECORD_CALL';
export const DELETE_REST_PUNCH_RECORD_DONE = 'DELETE_REST_PUNCH_RECORD_DONE';
export const DELETE_REST_PUNCH_RECORD_FAIL = 'DELETE_REST_PUNCH_RECORD_FAIL';

export const GET_PUNCH_IN_RULE_CALL = 'GET_PUNCH_IN_RULE_CALL';
export const GET_PUNCH_IN_RULE_DONE = 'GET_PUNCH_IN_RULE_DONE';
export const GET_PUNCH_IN_RULE_FAIL = 'GET_PUNCH_IN_RULE_FAIL';

export const GET_PUNCH_IN_SHIFT_CALL = 'GET_PUNCH_IN_SHIFT_CALL';
export const GET_PUNCH_IN_SHIFT_DONE = 'GET_PUNCH_IN_SHIFT_DONE';
export const GET_PUNCH_IN_SHIFT_FAIL = 'GET_PUNCH_IN_SHIFT_FAIL';

export const GET_PUNCH_IN_SHIFTS_BY_RANGE_CALL = 'GET_PUNCH_IN_SHIFTS_BY_RANGE_CALL';
export const GET_PUNCH_IN_SHIFTS_BY_RANGE_DONE = 'GET_PUNCH_IN_SHIFTS_BY_RANGE_DONE';
export const GET_PUNCH_IN_SHIFTS_BY_RANGE_FAIL = 'GET_PUNCH_IN_SHIFTS_BY_RANGE_FAIL';

export const SET_PUNCH_IN_STALE = 'SET_PUNCH_IN_STALE';

export const PUSH_PUNCH_IN_RETRY_OUTCOME = 'PUSH_PUNCH_IN_RETRY_OUTCOME';
export const CLEAR_PUNCH_IN_RETRY_OUTCOME = 'CLEAR_PUNCH_IN_RETRY_OUTCOME';

export const SET_ASYNC_PUNCH_ERROR_MODAL = 'SET_ASYNC_PUNCH_ERROR_MODAL';
export const CLEAR_ASYNC_PUNCH_ERROR_MODAL = 'CLEAR_ASYNC_PUNCH_ERROR_MODAL';

export const SET_ASYNC_PUNCH_INTERACTION_LOCK = 'SET_ASYNC_PUNCH_INTERACTION_LOCK';
export const CLEAR_ASYNC_PUNCH_INTERACTION_LOCK = 'CLEAR_ASYNC_PUNCH_INTERACTION_LOCK';
export const SET_MACHINE_PUNCH_ERROR = 'SET_MACHINE_PUNCH_ERROR';
